const buttons = document.querySelectorAll('[data-scroll-to]');

buttons.forEach((button) => {
    button.addEventListener('click', () => {
        const targetId = button.getAttribute('data-scroll-to');
        if (!targetId) return;

        const targetSection = document.querySelector(`[data-scroll-section-id="${targetId}"]`);
        if (!targetSection) {
            console.warn(`Nessuna sezione trovata con data-scroll-section-id="${targetId}"`);
            return;
        }

        // Recupera offset, se presente, altrimenti 0
        const offset = parseInt(button.getAttribute('data-scroll-offset'), 10) || 0;

        const top = targetSection.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
            top,
            behavior: 'smooth',
        });
    });
});
